import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-composites',
  templateUrl: './composites.component.html',
  styleUrls: ['./composites.component.css']
})
export class CompositesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
